// src/lib/arrivalsQuery.ts
//
// Query string for `GET /api/v1/ui/arrivals`. «Hoy»/«Mañana» are sent as `day`, never as a date
// computed in the browser: the server resolves each establishment's own business day (its time
// zone and day-closing hour), which the browser's or UTC's calendar gets wrong around midnight.

export interface ArrivalsQueryParams {
  date?: string;
  day?: 'today' | 'tomorrow';
  pendingOnly?: boolean;
  hotelIds?: string;
  hotelId?: string;
  groupId?: string;
}

export const buildArrivalsQuery = (params: ArrivalsQueryParams): Record<string, string | boolean> => {
  const query: Record<string, string | boolean> = {};
  if (params.date) query.date = params.date;
  else if (params.day === 'tomorrow') query.day = 'tomorrow';
  if (params.pendingOnly) query.pendingOnly = true;
  if (params.hotelIds) query.hotelIds = params.hotelIds;
  if (params.hotelId) query.hotelId = params.hotelId;
  if (params.groupId) query.groupId = params.groupId;
  return query;
};
